<template>
  <section class="answers-header">
    <span class="slide-number title mb-2">
      Slide {{ activity.lesson_slide.order }}
    </span>
    <!-- <v-row class="mb-2" align="center" justify="space-between">
      <v-chip label outlined flat disabled>Brainstorm activity</v-chip>
      <v-btn class="mx-3">
        <v-icon left>wb_iridescent</v-icon>
        View activity
      </v-btn>
    </v-row> -->
  </section>
</template>

<script>
export default {
  name: 'AnswersHeader',
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {}
}
</script>

<style lang="scss">
.answers-header {
  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }
}
</style>
